<label>{{getOptionByKey(attribute,'hideTitle') == 'true'? '' : attribute.key}}</label>
<div class="row">
    <app-dynamic *ngFor="let item of attribute.attributes" [class]="getSizeClass(item)" [attribute]="item" (change)="ngChangeInput($event, attribute.options)"></app-dynamic>
</div>
